"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCol = exports.TableRow = exports.TableFooter = exports.TableBody = exports.TableHeaderGroup = exports.TableHeader = exports.Table = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Table = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("table")
        .pmod(props.isStriped ? "striped" : "")
        .pmod(props.isCondensed ? "condensed" : "")
        .pmod(props.isSticky ? "sticky" : "")
        .pmod(props.isBordered ? "bordered" : "").boot;
    return ((0, jsx_runtime_1.jsx)("table", __assign({ ref: props === null || props === void 0 ? void 0 : props.setRef, id: props.id, className: "".concat(cls, " ").concat(props.className || "") }, { children: props.children })));
};
exports.Table = Table;
var TableHeader = function (props) {
    return (0, jsx_runtime_1.jsx)("th", __assign({}, props, { children: props.children }));
};
exports.TableHeader = TableHeader;
var TableHeaderGroup = function (props) {
    return ((0, jsx_runtime_1.jsx)("thead", __assign({}, props, { children: (0, jsx_runtime_1.jsx)(exports.TableRow, __assign({}, props.rowProps, { children: props.children })) })));
};
exports.TableHeaderGroup = TableHeaderGroup;
var TableBody = function (props) {
    return (0, jsx_runtime_1.jsx)("tbody", __assign({ style: props.style || {} }, { children: props.children }));
};
exports.TableBody = TableBody;
var TableFooter = function (props) {
    return (0, jsx_runtime_1.jsx)("tfoot", __assign({ style: props.style || {} }, { children: props.children }));
};
exports.TableFooter = TableFooter;
var TableRow = function (props) {
    return (0, jsx_runtime_1.jsx)("tr", __assign({}, props, { children: props.children }));
};
exports.TableRow = TableRow;
var TableCol = function (props) {
    return (0, jsx_runtime_1.jsx)("td", __assign({}, props, { children: props.children }));
};
exports.TableCol = TableCol;
var s = {
    Table: exports.Table,
    Col: exports.TableCol,
    Row: exports.TableRow,
    Body: exports.TableBody,
    Header: exports.TableHeaderGroup,
    HeaderCol: exports.TableHeader,
    Footer: exports.TableFooter
};
exports.default = s;
